import { ArrowRight, FileText } from "lucide-react";
import { POSTS } from "./BlogPost";

export default function FieldReportCard() {
    const [latest, ...older] = Object.values(POSTS);
    return (
        <div className="rounded-lg border border-subtle bg-white p-5" data-testid="field-report-card">
            <div className="flex items-center justify-between font-mono text-[10px] tracking-widest text-cyan-600 uppercase mb-3">
                <span className="inline-flex items-center gap-2">
                    <FileText className="h-3.5 w-3.5" /> {latest.ref} // BLOG
                </span>
                <span className="text-slate-400">{latest.byline.split("—")[1]?.trim()}</span>
            </div>
            <a href={`/blog/${latest.slug}`} className="group block" data-testid="field-report-latest">
                <h3 className="font-display text-base sm:text-lg font-bold text-slate-900 leading-snug mb-2 group-hover:text-cyan-800 transition-colors">
                    {latest.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed mb-3">{latest.summary}</p>
                <span className="inline-flex items-center gap-2 font-mono text-xs tracking-widest text-cyan-700">
                    READ FIELD REPORT
                    <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
            </a>
            {older.length > 0 && (
                <ul className="mt-4 pt-4 border-t border-subtle space-y-1.5" data-testid="field-report-archive">
                    {older.map((p) => (
                        <li key={p.slug}>
                            <a href={`/blog/${p.slug}`} className="group flex items-baseline gap-3 text-sm" data-testid={`field-report-${p.slug}`}>
                                <span className="font-mono text-[10px] text-slate-400 shrink-0">{p.ref.replace("FIELD REPORT ", "")}</span>
                                <span className="text-slate-600 group-hover:text-cyan-700 transition-colors">{p.title}</span>
                            </a>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
